import { createMutationHelper } from '@utils/swr'
import { type CampaignFirebaseKeyRequest } from '../types/apiRequest'
import { type FortuneFirebaseKeyResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['get']['firebaseKey'], FortuneFirebaseKeyResponse, CampaignFirebaseKeyRequest>({
  client: 'fortune',
  key: 'campaigns/:campaign_code/payment_transactions/:order_hash/firebase-key',
  fetcher: (_, { client, arg }) => {
    if (!arg.code || !arg.order_hash) {
      return Promise.reject(new Error('[useApiCampaignFirebaseKey] code or order_hash are required!'))
    }
    return client.get(`/campaigns/${arg.code}/payment_transactions/${arg.order_hash}/firebase-key`)
  },
})

export const useApiMutationCampaignFirebaseKey = useMutation
